export enum FileCenterActionType {
  /**
   * @description 未設定
   */
  NONE,
  /**
   * @description 唯讀模式
   */
  VIEW,
  /**
   * @description 可編輯模式
   */
  EDIT,
}
